export const updateHistoryState = (state, forceUpdate = false, location, navigate) => {
    const historyState = forceUpdate ? state : { ...(location.state || {}), ...state };
    navigate({ ...location, state: historyState });
};
